<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Modifier Catégorie
            </strong>
          </div>
          <b-form>
            <b-form-group
              description="Libellé"
              label="Libellé"
              label-for="basicName"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input id="basicName" type="text" autocomplete="name" v-model="libelle"></b-form-input>
              <span class='field-error'>{{ errors.libelle }}</span>
            </b-form-group>

            <b-form-group
              description="Libellé technique"
              label="Libellé technique"
              label-for="basicText"
              :label-cols="3"
              :horizontal="true"
            >
              <b-form-input id="basicText" type="text" placeholder="Text" v-model="libelle_technique"></b-form-input>
              <span class='field-error'>{{ errors.libelle_technique }}</span>
            </b-form-group>

            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des statuts
              </b-button>
              <b-button type="button" @click="saveCategorie" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'

export default {
  data() {
    return {
      libelle: '',
  	  libelle_technique: '',
      errors: {
        libelle: '',
        libelle_technique: ''
      }
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();

    if (this.$route.params.id) {
      this.populateCategorie();
    }
  },
  methods: {
    populateCategorie() {
      this.$store.commit("IS_LOADING", true);
      let categorieId = this.$route.params.id;
      let self = this;
      this.$axios
        .get("/administration/categories/edit/" + categorieId)
        .then(response => {
          this.libelle = response.data.categorie.libelle;
          this.libelle_technique = response.data.categorie.libelle_technique;
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          if (
            error.response &&
            error.response.status === 404 &&
            self != undefined
          ) {
            self.$router.push({ path: "/administration/statuts" });
            self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: "La catégorie avec l'id " + id + " n'existe pas",
              showConfirmButton: false,
              timer: 5000
            });
          }
        });
    },
    saveCategorie() {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true);
        let self = this;
        let dataPost = {};
        let categorieId = this.$route.params.id;

        dataPost.libelle = this.libelle;
        dataPost.libelle_technique = this.libelle_technique;

        this.$axios
          .put("/administration/categories/" + categorieId, dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$swal({
              position: "top",
              type: "success",
              title: "Modification avec succès",
              text: 'La catégorie ' + dataPost.libelle + ' a bien été modifiée',
              showConfirmButton: false,
              timer: 5000
            });
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    returnBack() {
      this.$router.push({ path: "/administration/statuts" });
    },
    formatDate(textDate) {
      let date =
        textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "";
      return date;
    },
    validateData() {
      this.clearErrors();
      let regAlpha = this.$store.getters.getRegAlpha
      let regAlphaUnderscore = this.$store.getters.getRegAlphaUnderscore
      let valid = true
      
      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid= false;
      } else if (!regAlpha.test(this.libelle.trim())) {
        valid = false
        this.errors.libelle  = 'Veuillez entrer un libellé valide'
      }

      if (this.libelle_technique === '') {
        this.errors.libelle_technique = 'Le libelle technique est obligatoire'
        valid= false
      } else if (!regAlphaUnderscore.test(this.libelle_technique.trim())) {
        valid = false
        this.errors.libelle_technique  = 'Veuillez entrer un libellé technique valide'
      }
      return valid;
    },
    clearErrors() {
      this.errors.libelle = "";
      this.errors.libelle_technique = "";
    }
  }
}
</script>

<style>

</style>
